import React from 'react';
import { AnimatedSection } from './AnimatedSection';
import { AlertTriangleIcon } from 'lucide-react';
export function ProblemSection() {
  return <AnimatedSection className="px-4 py-8 md:py-14" data-id="element-80">
      <div className="max-w-3xl mx-auto" data-id="element-81">
        <h2 className="font-playfair text-2xl md:text-4xl font-bold text-center mb-8 md:mb-12" data-id="element-82">
          Seamos honestos...
        </h2>

        <p className="text-gray-300 text-base md:text-lg leading-relaxed mb-8 text-center" data-id="element-83">
          El mercado cambió. Hoy en día, una imagen con "stock de Google" o un
          anuncio aburrido es el billete directo al{' '}
          <span className="text-red-400 font-semibold" data-id="element-84">
            cementerio de los anuncios.
          </span>
        </p>

        <div className="space-y-4 mb-10" data-id="element-85">
          {['Tu competencia está usando visuales de alta gama.', 'Tu audiencia es más exigente que nunca.', 'Y tú... te sientes atrapada entre pagar miles a una agencia o conformarte con diseños mediocres.'].map((item, i) => <div key={i} className="flex items-start gap-3 bg-[#111111] border border-red-900/20 rounded-sm p-4 md:p-5" data-id="element-86">
              <AlertTriangleIcon className="w-5 h-5 text-red-400 mt-0.5 flex-shrink-0" data-id="element-87" />
              <p className="text-gray-200 text-sm md:text-base" data-id="element-88">{item}</p>
            </div>)}
        </div>

        <p className="text-center text-xl md:text-2xl font-playfair text-[#d4a853] font-semibold" data-id="element-89">
          Pero, ¿y si pudieras ganarle a las agencias en su propio juego?
        </p>
      </div>
    </AnimatedSection>;
}